export type WithTotalCount = { group_name: string; total_count: number };
export type WithAggregate = { name: string; currency?: string } & Record<
  string,
  { aggregate: { count: number } } | number
>;
type BarItem = WithTotalCount | WithAggregate;

const mapBarTotalCount = (
  item: WithTotalCount,
): { name: string; value: number } => ({
  name: item.group_name,
  value: item.total_count,
});

const mapBarAggregate = (
  item: WithAggregate,
): { name: string; value: number; currency?: string } => {
  const aggregateKey = Object.keys(item).find(
    (key) => key !== 'name' && key.endsWith('_aggregate'),
  );
  if (!aggregateKey) throw new Error('No aggregate property found in item');
  return {
    name: item.name,
    value:
      typeof item[aggregateKey] === 'number'
        ? item[aggregateKey]
        : item[aggregateKey].aggregate.count,
    currency: item.currency ?? undefined,
  };
};

const isWithTotalCount = (item: BarItem): item is WithTotalCount => {
  return (item as WithTotalCount).total_count !== undefined;
};

export const mapBar = (
  item: BarItem,
): { name: string; value: number; currency?: string } => {
  // console.log('item', item);
  if (isWithTotalCount(item)) {
    return mapBarTotalCount(item);
  }
  return mapBarAggregate(item);
};
